define([
  "marionette",
  "jquery",
  "underscore",
  "./template/topicCopyResponseSearchTopicTemplate.html",
], function (Marionette, $, _, TopicCopyResponseSearchTopicTemplate) {
  "use strict";

  let TopicCopyResponseSearchTopicView = {};

  TopicCopyResponseSearchTopicView.searchTopicView = Marionette.Layout.extend({
    template: TopicCopyResponseSearchTopicTemplate,
    regions: {
      searchBar: "#topicSelector",
    },
    getRadioValue: function () {
      return $('input[type="radio"][name="topic"]:checked').val();
    },
    showError: function () {
      const message = $.t("topic.copyResponse.search.error");
      this.$el.find("#copyResponseError").text(message).show();
    },
    hideError: function () {
      this.$el.find("#copyResponseError").hide();
    },
  });

  return TopicCopyResponseSearchTopicView;
});
